import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

import {cookiesEnabled} from '../utils/cookiesEnabled';
import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

import '../components/fields';

import "../styles/theme.scss";
import { docReady } from "../utilities";
import Braze from "../libraries/Braze";

docReady(function() {
    document.body.classList.add('ready');
});

// Stamp the market and identify the Braze user as early as possible (external_id =
// Shopify customer.id, injected by theme.liquid) so any anonymous activity (e.g.
// footer/popup online_signup events) carries the market and merges into the
// server-synced profile on this device.
Braze.identify(window.__braze || {});

// Wipe the Braze profile as the logout link is clicked, so the next visitor on a shared
// device does not keep firing events against the previous customer. Delegated because
// customer_logout_link (snippets/account-sidebar.liquid) renders the anchor server-side.
// The navigation is never cancelled or awaited: logout still works with JS disabled or
// the SDK absent, and the next page finishes any wipe the SDK was not ready for.
document.addEventListener('click', function (event) {
    const target = event.target;
    const link = target && target.closest && target.closest('a[href$="/account/logout"]');
    if (!link) return;
    Braze.logoutCleanup();
});

// Common a11y fixes
focusHash();
bindInPageLinks();


// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    "supports-no-cookies",
    "supports-cookies"
  );
}
